import { GetStaticProps } from "next"
import { Box, Container, Grid } from "@mui/material"
import Icon from "@mdi/react"
import { mdiPackageVariantClosed, mdiFaceAgent, mdiShieldAccount } from "@mdi/js"

import BreadCrumbs, { BreadCrumbAncestor } from "components/BreadCrumbs"

import useTranslation from "hooks/useTranslation"

import { getServerTranslations } from "utils/i18n/getServerTranslations"
import { helpCenterBreadCrumb } from "./index"

const AboutPage = () => {
	const { t } = useTranslation("help")

	const breadCrumb: BreadCrumbAncestor = {
		label: t("aboutSafehero"),
		href: "/help/about",
	}

	return (
		<Box
			my={5}
			style={{
				background:
					"url(https://res.cloudinary.com/safehero/image/upload/v1571664485/HelpCenter/UeberSafeHeroBg_oxvk5v.png)",
				width: "100%",
				objectFit: "contain",
			}}
		>
			<Box style={{ marginTop: "-40px", paddingBottom: "20px" }}>
				<BreadCrumbs
					breadCrumbsPaths={[
						{ ...helpCenterBreadCrumb, label: t(helpCenterBreadCrumb.label) },
					]}
					currentPath={breadCrumb}
				/>
			</Box>
			<Container>
				<Grid container spacing={3}>
					<Grid item xs={12} md={1}></Grid>
					<Grid item xs={12} md={5}>
						<Box pt={3} style={{ margin: "auto", textAlign: "center" }}>
							<img
								alt="safehero"
								style={{ maxWidth: "450px", width: "100%" }}
								src="https://res.cloudinary.com/safehero/image/upload/v1571664483/HelpCenter/Safehero_usu3jz.png"
							/>
						</Box>
					</Grid>
					<Grid item xs={12} md={5}>
						<h1>{t("aboutSafehero")}</h1>
						<p style={{ color: "grey" }}>{t("teamText1")}</p>
						<p>{t("teamText2")}</p>
					</Grid>
					<Grid item xs={12} md={1}></Grid>
					<Grid item xs={12} md={1}></Grid>
					<Grid item xs={12} md={5}>
						<h2 style={{ maxWidth: "400px" }}>{t("threeCoreStrengths")}</h2>
						<Box mt={3}>
							<Icon path={mdiPackageVariantClosed} color="#7abfac" size={1} />
							<br />
							<strong>{t("choice")}</strong>
						</Box>
						<p>
							{t("bigSortiment")} <br />
							{t("bigSortimentText")}
						</p>
						<Box mt={3}>
							<Icon path={mdiFaceAgent} color="#7abfac" size={1} />
							<br />
							<strong>{t("service")}</strong>
						</Box>
						<p>
							{t("excellentService")} <br />
							{t("excellentServiceText")}
						</p>
						<Box mt={3}>
							<Icon path={mdiShieldAccount} color="#7abfac" size={1} />
							<br />
							<strong>{t("dataPrivacy")}</strong>
						</Box>
						<p>{t("dataPrivacyText")}</p>
					</Grid>
					<Grid item xs={12} md={5}>
						<Box pt={5} style={{ margin: "auto", textAlign: "center" }}>
							<img
								alt="quote"
								style={{ maxWidth: "400px" }}
								src="https://res.cloudinary.com/safehero/image/upload/v1571664482/HelpCenter/Leitgeb_bd973q.png"
							/>
						</Box>
						<Box style={{ position: "relative", minHeight: "320px" }}>
							<div
								style={{
									position: "absolute",
									background: "#f7fafa",
									padding: "20px",
									marginLeft: "80px",
									marginTop: "-30px",
									zIndex: 1,
									boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
								}}
							>
								<p>{t("founderStatement")}</p>
								<p style={{ textAlign: "right" }}>- Richard Leitgeb</p>
							</div>
						</Box>
					</Grid>
					<Grid item xs={12} md={1}></Grid>
				</Grid>
			</Container>
		</Box>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const props = {
		...(await getServerTranslations(context.locale, [
			"common",
			"countries",
			"languages",
			"help",
		])),
	}

	return {
		props,
	}
}

export default AboutPage
